//Drag and drop constants
export const DRAG_AND_DROP_OPTIONS = {
  WEEKLY_OPEN_SHIFT: 'weeklyOpenShift',
  WEEKLY_BOOKED_SHIFT: 'weeklyBookedShift',
  WEEKLY_UNBOOK_EMPLOYEE: 'weeklyUnbookEmployee',
  DAILY_OPEN_SHIFT: 'dailyyOpenShift',
  DAILY_BOOKED_SHIFT: 'dailyBookedShift',
  DAILY_UNBOOK_EMPLOYEE: 'dailyUnbookEmployee'
};
